import { Link } from "@tanstack/react-router";

export function SidebarBrand() {
  return (
    <Link
      to="/app/dashboard"
      className="flex items-center gap-3 rounded-lg px-2 py-2 no-underline outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>span]:last:truncate"
    >
      <div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-sidebar-border bg-sidebar-primary text-sidebar-primary-foreground">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="size-5"
          aria-hidden
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-semibold text-sidebar-foreground">
          ຝ່າງ PORTAL
        </span>
        <span className="truncate text-xs text-sidebar-foreground/70">
          Employee Self-Service
        </span>
      </div>
    </Link>
  );
}
